import { RawItemTypeWithItems } from '../../../../Stores/ProjectStore';

export const HasItems = (
    itemTypeId: number,
    itemTypesWithItems: RawItemTypeWithItems[]
): boolean => {
    const currentItemType = itemTypesWithItems.find(
        (itemType: RawItemTypeWithItems) => itemType.id === itemTypeId
    );

    if (!currentItemType) {
        return false;
    }

    return currentItemType.items.data.length > 0;
};
